import React from 'react';
import { SvgIcon } from '@mui/material';

function InvoiceIcon({ ...props }) {
  return (
    <SvgIcon {...props} viewBox="0 0 59 67">
      <path
        d="M1.6141 49.7786L26.8867 2.04639L57.6817 18.3513L31.9042 65.8162L31.734 62.4754L28.8752 64.2125L28.705 60.8716L25.8462 62.6087L25.676 59.2679L22.8172 61.0049L22.647 57.6641L19.7882 59.4012L19.618 56.0604L16.7592 57.7974L16.5889 54.4566L13.7302 56.1937L13.5599 52.8528L10.7011 54.5899L10.5309 51.2491L7.67213 52.9861L7.50191 49.6453L4.64311 51.3824L4.47289 48.0415L1.6141 49.7786Z"
        stroke="currentColor"
        strokeWidth="2.25"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1="14.8591"
        y1="31.0916"
        x2="39.6091"
        y2="44.5916"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeDasharray="3 3"
      />
      <path
        d="M18.8237 51.7549L25.5613 39.8993L26.3208 40.3309L19.5832 52.1866L18.8237 51.7549ZM26.0964 44.9088C26.3075 44.4079 26.2892 43.9155 26.0414 43.4316C25.7936 42.9477 25.3825 42.5425 24.8083 42.2162C24.3884 41.9776 23.9824 41.8367 23.5903 41.7936C23.2012 41.7522 22.8512 41.8004 22.5401 41.9381C22.2321 42.0776 21.9921 42.2986 21.8202 42.6011C21.6763 42.8543 21.6128 43.1062 21.6297 43.3568C21.6514 43.606 21.7238 43.8452 21.8468 44.0744C21.9715 44.3005 22.1169 44.5118 22.283 44.7083C22.4509 44.9018 22.6096 45.0716 22.7593 45.2179L23.5752 46.0247C23.7853 46.2299 24.0092 46.4756 24.2468 46.7618C24.4876 47.0497 24.6907 47.3714 24.8563 47.7269C25.0267 48.0811 25.1162 48.4628 25.1246 48.872C25.1331 49.2811 25.011 49.708 24.7583 50.1526C24.467 50.6651 24.0696 51.0519 23.5658 51.313C23.0652 51.5758 22.4893 51.6835 21.8382 51.6362C21.1902 51.5906 20.5018 51.3607 19.7732 50.9466C19.094 50.5606 18.5681 50.1168 18.1956 49.6151C17.8262 49.1151 17.6109 48.5884 17.5497 48.0349C17.4916 47.4831 17.5914 46.9374 17.8491 46.3976L19.0347 47.0714C18.862 47.4471 18.814 47.8119 18.8906 48.1659C18.972 48.5185 19.1424 48.844 19.4016 49.1425C19.6657 49.4396 19.9861 49.6952 20.3628 49.9093C20.8012 50.1584 21.2352 50.3111 21.6648 50.3674C22.0961 50.4205 22.4865 50.3769 22.8359 50.2364C23.187 50.0929 23.4608 49.8482 23.6574 49.5024C23.8363 49.1875 23.894 48.8813 23.8303 48.5837C23.7666 48.286 23.6263 47.9939 23.4093 47.7072C23.1924 47.4206 22.9435 47.1362 22.6627 46.8541L21.6852 45.8574C21.0653 45.2233 20.6515 44.5858 20.4438 43.945C20.2362 43.3041 20.3139 42.6642 20.6771 42.0251C20.9789 41.494 21.3857 41.1125 21.8974 40.8805C22.414 40.6472 22.9784 40.5595 23.5908 40.6175C24.208 40.6742 24.8192 40.8745 25.4243 41.2184C26.0356 41.5658 26.5167 41.9842 26.8676 42.4736C27.2203 42.9599 27.4285 43.4704 27.4923 44.005C27.5592 44.5413 27.4644 45.0531 27.2079 45.5404L26.0964 44.9088Z"
        fill="currentColor"
      />
      <line
        x1="20.8803"
        y1="24.3535"
        x2="33.6303"
        y2="31.8535"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <line
        x1="26.8779"
        y1="13.1022"
        x2="44.8779"
        y2="23.6022"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <line
        x1="23.8779"
        y1="18.3522"
        x2="41.8779"
        y2="28.8522"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </SvgIcon>
  );
}

export default InvoiceIcon;
